/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentContentFolderRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/content-folder';

export default class AutomationFinAIAgentEcommerceContentFolderRoute extends AutomationFinAIAgentContentFolderRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.content-folder',
  };

  protected get contentRoute(): string {
    return 'apps.app.automation.fin-ai-agent.ecommerce.content';
  }
}
